import {BrowserRouter, Routes, Route, } from 'react-router-dom'
import Body from './pages/Body';
import Header from './components/Header';
import Durante from './pages/Durante'
import Alllegar from './pages/Alllegar';
import DocumentacionParaViajar from './components/documentacion/DocumentacionParaViajar';
import ViajarConAuto from './components/documentacion/ViajarConAuto';
import MenoresEdad from './components/documentacion/MenoresEdad';
import ViajarConMascotas from './components/documentacion/ViajarConMascotas';
import DocumentacionAdultoMayor from './components/documentacion/DocumentacionAdultoMayor';
import DocumentacionEmbarazada from './components/documentacion/DocumentacionEmbarazada';
import ListoParaViajar from './components/recomendaciones/ListoParaViajar';
import ViajasConVehiculo from './components/recomendaciones/ViajasConVehiculo';
import ViajasConMoto from './components/recomendaciones/ViajasConMoto';
import Mareos from './components/recomendaciones/Mareos';
import MovilidadReducida from './components/recomendaciones/MovilidadReducida';
import MujeresEmbarazadas from './components/recomendaciones/MujeresEmbarazadas';
import ComoLLegar from './components/temas/ComoLLegar';
import Embarque from './components/temas/Embarque';
import EmbarqueAuto from './components/temas/EmbarqueAuto';
import Incluye from './components/temas/Incluye';
import Equipaje from './components/Equipaje';
import DesembarqueAuto from './components/desembarque/DesembarqueAuto'
import DesembarquePasajero from './components/desembarque/DesembarquePasajero';
import DesembarqueCarga from './components/desembarque/DesembarqueCarga';
import RevisionAutoridades from './components/RevisionAutoridades';
import EquipajeAntes from './components/recomendaciones/Equipaje'
import Factura from './components/Facturacion'
import { RouteProvider } from "./context/RouteContext";
import QueIncluye from './components/Incluye';
import Entretenimiento from './components/Entretenimiento';
import ConectaTuViaje from './components/ConectaTuViaje';
import ScrollToTop from './components/ScrollToTop'
import ServiciosAdicionales  from './components/ServiciosAdicionales'



function App() {
  return (
    <RouteProvider>
        <BrowserRouter>
          <ScrollToTop />


            <Routes>
                <Route path="/" element={<Header />}>
                    <Route index element={<Body />} />
                    <Route path="durante-tu-viaje" element={<Durante />} />
                    <Route path="al-llegar" element={<Alllegar />} />

                    <Route path="documentacion-para-viajar" element={<DocumentacionParaViajar />} />
                    <Route path="viajar-con-auto" element={<ViajarConAuto />} />
                    <Route path="viajar-con-menores-de-edad" element={<MenoresEdad />} />
                    <Route path="viajar-con-mascotas" element={<ViajarConMascotas />} />
                    <Route path="viajar-con-adulto-mayor" element={<DocumentacionAdultoMayor />} />
                    <Route path="documentacion-para-mujeres-embarazadas" element={<DocumentacionEmbarazada />} />

                    <Route path="listo-para-viajar" element={<ListoParaViajar />} />
                    <Route path="viajas-con-vehiculo" element={<ViajasConVehiculo />} />
                    <Route path="viajas-con-moto" element={<ViajasConMoto />} />
                    <Route path="mareos" element={<Mareos />} />
                    <Route path="movilidad-reducida" element={<MovilidadReducida />} />

                    <Route path="mujeres-embarazadas" element={<MujeresEmbarazadas />} />
                    <Route path="como-llegar" element={<ComoLLegar />} />
                    <Route path="proceso-de-dembarque" element={<Embarque />} />
                    <Route path="proceso-de-dembarque-con-vehiculo" element={<EmbarqueAuto />} />
                    <Route path="que-incluye-tu-boleto" element={<Incluye />} />
                    <Route path="revision-autoridades" element={<RevisionAutoridades />} />

                    <Route path="desembarque-con-automovil" element={<DesembarqueAuto />} />
                    <Route path="desembarque-pasajero" element={<DesembarquePasajero />} />
                    <Route path="desembarque-con-unidades-de-carga" element={<DesembarqueCarga />} />
                    <Route path="factura-abordo" element={<Factura />} />
                    <Route path="recepcion-equipaje" element={<Equipaje />} />
                    
                    <Route path="equipaje" element={<EquipajeAntes />} />
                    <Route path="que-incluye" element={<QueIncluye />} />
                    <Route path="servicios-adicionales" element={<ServiciosAdicionales />} />
                    <Route path="entretenimiento" element={<Entretenimiento />} />
                    <Route path="conecta-tu-viaje" element={<ConectaTuViaje />} />
                    <Route path="revision-de-autoridades" element={<RevisionAutoridades />} />
                </Route>     

            </Routes>
        </BrowserRouter>
    </RouteProvider>
  );
}


export default App;


